import { render, staticRenderFns } from "./CrewRemark.vue?vue&type=template&id=e2760be8&scoped=true"
import script from "./CrewRemark.vue?vue&type=script&lang=js"
export * from "./CrewRemark.vue?vue&type=script&lang=js"
import style0 from "./CrewRemark.vue?vue&type=style&index=0&id=e2760be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2760be8",
  null
  
)

export default component.exports